import {
  Typography,
  MenuItem,
  ListItemText,
  Divider,
  ListItemIcon,
  Stack,
} from '@mui/material'
import { styled } from '@mui/material/styles'
import { ArrowIOSIcon } from '$common/icons/arrow-ios'

const StyledMenuItem = styled(MenuItem)`
  padding: 0 25px 0 20px;
  box-sizing: border-box;
  &.Mui-disabled {
    opacity: 1;
  }
`
interface ListItemProps {
  disabled?: boolean
}

const StyledListItemIcon = styled(ListItemIcon)<ListItemProps>(
  ({ disabled }) => ({
    opacity: disabled ? 0.5 : 1,
  }),
)

const Title = styled(Typography)<ListItemProps>(({ disabled }) => ({
  opacity: disabled ? 0.5 : 1,
}))

const IntendedDivider = styled(Divider)`
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  &.MuiDivider-inset {
    margin-right: 20px;
  }

  &:last-child {
    display: none;
  }
`

interface Prop {
  value: string
  isLeaf?: boolean
  alignedCenter?: boolean
  onClick: (value: string) => any | Promise<any>
  icon?: JSX.Element
  height: number
  disabled?: boolean | undefined
  badge?: JSX.Element | undefined
}
export function SelectMenuOption({
  value,
  isLeaf = false,
  alignedCenter = false,
  onClick,
  icon,
  height,
  disabled = false,
  badge,
}: Prop) {
  return (
    <>
      <StyledMenuItem
        disabled={disabled}
        sx={{ minHeight: `${height}px`, height: `${height}px` }}
        onClick={() => onClick(value)}
      >
        {icon && (
          <StyledListItemIcon disabled={disabled}>{icon}</StyledListItemIcon>
        )}
        <ListItemText
          sx={{
            display: 'flex',
            textAlign: alignedCenter ? 'center' : 'unset',
          }}
        >
          <Stack direction="row" alignItems="center" gap="8px">
            <Title disabled={disabled} variant="body2">
              {value}
            </Title>
            {badge && <>{badge}</>}
          </Stack>
        </ListItemText>

        {!isLeaf && !disabled && <ArrowIOSIcon />}
      </StyledMenuItem>

      <IntendedDivider variant="inset" />
    </>
  )
}
